import React, { useState } from "react";
import { Box, Button, Text } from "@mantine/core";
import {
  DEFAULT_THEME,
  PLAYER_NAME_MAX_LENGTH,
} from "../../shared/util/consts";

type JoinGameInterface = {
  savedName: string;
  savedCode: string;
  onSubmit: (name: string, roomCode: string) => void;
};

const JoinGame: React.FC<JoinGameInterface> = ({
  savedName = "",
  savedCode = "",
  onSubmit,
}) => {
  const [name, setName] = useState(savedName);
  const [code, setCode] = useState(savedCode);

  return (
    <Box
      style={{
        width: "100%",
        alignItems: "center",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        justifyContent: "center",
      }}
    >
      <Text style={{ fontSize: "30px" }}>Join a Game!</Text>
      <input
        placeholder={"NAME"}
        value={name}
        onChange={(evt) => {
          const fixedValue = evt.target.value.trim().toUpperCase();
          if (fixedValue.length <= PLAYER_NAME_MAX_LENGTH) {
            setName(fixedValue);
          }
        }}
        style={{
          width: "50%",
          height: "50px",
          minWidth: "200px",
          fontSize: "30px",
          textAlign: "center",
          textTransform: "uppercase",
        }}
      />
      <input
        placeholder={"CODE"}
        value={code}
        type={"text"}
        maxLength={4}
        pattern={"[A-Z]{4}"}
        minLength={4}
        onChange={(evt) => {
          const trimmedValue = evt.target.value.trim();
          if (trimmedValue.length <= 4) {
            setCode(trimmedValue.toUpperCase());
          }
        }}
        style={{
          width: "50%",
          height: "50px",
          minWidth: "200px",
          fontSize: "30px",
          textAlign: "center",
          marginTop: "10px",
          textTransform: "uppercase",
        }}
      />
      <Button
        onClick={() => onSubmit(name, code)}
        style={{
          backgroundColor: DEFAULT_THEME.BackgroundColor,
          color: DEFAULT_THEME.TextColor,
          fontSize: "24px",
          border: "1px solid #fff",
          borderRadius: "5px",
          width: "50%",
          minWidth: "200px",
          marginTop: "20px",
          height: "50px",
        }}
      >
        Join Game
      </Button>
    </Box>
  );
};

export default JoinGame;
